<div class="visualisation-container">
  <gl-loading-space-preview
    [width]="230"
    [height]="190"
    [loadingSpaceType]="loadingSpaceMod"
    [project]="project"
    view="setLeft"
    [isOrto]="true"
  ></gl-loading-space-preview>
</div>
<div class="setForm">
  <form (keyup.enter)="onSubmit()" [formGroup]="form">
    @if (loadingSpace?.type === 1) {
      <h3 class="formTitle">{{ 'trailer' | translate }}</h3>
    }
    @if (loadingSpace?.type === 2) {
      <h3 class="formTitle">{{ 'container' | translate }}</h3>
    }
    <div class="input-row">
      <gl-input-container class="input" [glPremium]="true" [units]="'length'" >
        <input
          data-ctx="input-length1"
          [numericType]="'float'"
          formControlName="length1"
          normal-input
          placeholder="length"
          type="text"
          />
      </gl-input-container>
      <gl-input-container class="input" [glPremium]="true" [units]="'length'">
        <input
          [numericType]="'float'"
          formControlName="width1"
          normal-input
          placeholder="width"
          type="text"
          />
      </gl-input-container>
      <gl-input-container class="input" [glPremium]="true" [units]="'length'">
        <input
          [numericType]="'float'"
          formControlName="height1"
          normal-input
          placeholder="height"
          type="text"
          />
      </gl-input-container>
    </div>
    <div class="input-row">
      <gl-input-container class="input" [glPremium]="true" [units]="'weight'">
        <input
          [numericType]="'float'"
          formControlName="limit1"
          normal-input
          placeholder="limit"
          type="text"
          />
      </gl-input-container>

      @if (typeLoadingSpace !== 1 && loadingSpace?.type !== 1) {
        <gl-select class="input" placeholder="loading" formControlName="semiTrailerLoadingSide">
          <gl-option [value]="'back'" label="{{ 'back_side' | translate }}"></gl-option>
          <gl-option [value]="'right'" label="{{ 'right_side' | translate }}"></gl-option>
          <gl-option [value]="'left'" label="{{ 'left_side' | translate }}"></gl-option>
          <gl-option [value]="'top'" label="{{ 'top_side' | translate }}"></gl-option>
        </gl-select>
      }

      <div class="input" style="padding: 0 10px"></div>
    </div>
    <div class="buttonRow">
      <button (click)="formReset()" outline-icon-button type="button">
        <gl-icon name="delete"></gl-icon>
      </button>
      <button (click)="reload()" outline-icon-button type="button">
        <gl-icon name="startArrangement"></gl-icon>
      </button>
    </div>
  </form>
</div>
